export const links = {
  CONNECT_WITH_SEEK: {
    name: 'Connect with SEEK',
    path: '/partners/connect-with-seek',
    tracking: 'connect-with-seek-link-clicked',
  },
  CONNECTED_PARTERS: {
    name: 'Connected Partners',
    path: '/connected-partners',
    tracking: 'connected-partners-link-clicked',
  },
  LINK_YOUR_SOFTWARE: {
    name: 'Link your software',
    path: '/link-your-software',
    tracking: 'link-your-software-link-clicked',
  },
  INTEGRATION_REQUEST: {
    name: 'Integration request',
    path: '/integration-request',
    tracking: 'integration-request-link-clicked',
  },
};
